/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const CANCEL_CALLBACK_URL = "/api/callback/cancel";
export const CREATE_CALLBACK_URL = "/api/callback/create";
export const GET_RESTRICTIONS_URL = "/api/callback/restrictions";
export function cancelCallback(id) {
    return apiService.post(CANCEL_CALLBACK_URL, true, {
        id
    });
}
export function createCallback(model) {
    return apiService.post(CREATE_CALLBACK_URL, true, {
        model
    });
}
export function getRestrictions() {
    return apiService.post(GET_RESTRICTIONS_URL, true, {});
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/callback.ts